'use strict';

var angular = require('angular');
var SortCustomizationDropdownController = function SortCustomizationDropdownController($scope, SortColumn) {
  $scope.columns = [];
  $scope.currentSortColumn = undefined;
  $scope.setDropdownOptions = function (sortOptions) {
    $scope.columns = sortOptions.availableOptions;
  };
  $scope.sortColumn = function (sortColumn) {
    if (arguments.length === 1) {
      if (angular.isDefined(sortColumn)) {
        $scope.currentSortColumn.field = sortColumn.field;
        $scope.currentSortColumn.setFieldAlias(sortColumn.fieldAlias);
        if ($scope.isNotSorted()) {
          $scope.setSortDirection(SortColumn.SORT_DIRECTION_ASC);
        }
      } else {
        $scope.currentSortColumn.reset();
      }
      $scope.fireSortColumnChanged($scope.index);
    }
    return $scope.currentSortColumn.field === '' ? undefined : $scope.currentSortColumn;
  };
  $scope.isNotSorted = function () {
    return $scope.currentSortColumn.isNotSorted();
  };
  $scope.isSortAscending = function () {
    return $scope.currentSortColumn.isSortAscending() || $scope.isNotSorted();
  };
  $scope.isSortDescending = function () {
    return $scope.currentSortColumn.isSortDescending();
  };
  $scope.setSortDirection = function (sortDirection) {
    var availableOptions = $scope.columns.map(function (option) {
      return option.field;
    });
    if (availableOptions.indexOf($scope.currentSortColumn.field) !== -1) {
      $scope.currentSortColumn.setSortDirection(sortDirection);
    }
  };
};
SortCustomizationDropdownController.$inject = ['$scope', 'SortColumnFactory'];
module.exports = SortCustomizationDropdownController;